import { AlertTriangle, Clock, Wrench } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function MaintenanceScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="relative">
            <div className="h-24 w-24 bg-yellow-500/20 rounded-full flex items-center justify-center">
              <Wrench className="h-12 w-12 text-yellow-500" />
            </div>
            <div className="absolute -top-2 -right-2">
              <div className="h-8 w-8 bg-orange-500/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="h-4 w-4 text-orange-500" />
              </div>
            </div>
          </div>
        </div>

        <Card className="border-yellow-200 bg-yellow-50/50 dark:border-yellow-800 dark:bg-yellow-900/20">
          <CardContent className="pt-6">
            <h1 className="text-2xl font-bold text-foreground mb-2">
              Wartungsarbeiten
            </h1>
            <p className="text-muted-foreground mb-4">
              Unsere Website befindet sich momentan im Wartungsmodus. 
              Wir arbeiten daran, Ihnen ein noch besseres Erlebnis zu bieten.
            </p>
            
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              <span>Wir sind bald wieder da</span>
            </div>
          </CardContent>
        </Card>

        <div className="text-sm text-muted-foreground">
          Bei dringenden Fragen wenden Sie sich bitte an: 
          <br />
          <a href="mailto:admin@asc-fechten.de" className="text-primary hover:underline">
            admin@asc-fechten.de
          </a>
        </div>
      </div>
    </div>
  );
}